import {OfferedEmployeeStatus} from "./Enums/OfferedEmployeeStatus";

export class OfferedChangedStatus {
	offeredName: string;
	changedStatus: OfferedEmployeeStatus;
	offeredBu: string;

	constructor(employeeName: string, changedStatus: OfferedEmployeeStatus, offeredBu: string) {
		this.offeredName = employeeName;
		this.changedStatus = changedStatus;
		this.offeredBu = offeredBu;
	}
}
